const addMessageTimelineActionStr = {
  toastr: 'Mensaje Agregado'
};

export default addMessageTimelineActionStr;
